import { ref, computed } from "vue";

const interfaceGlobalProperties = ref({
    sidebarOpen: true,
    fontSize: 15,
    theme: "lara-light-blue",
});

export const useInterfaceProperties = () => {
    const sidebarOpen = computed(
        () => interfaceGlobalProperties.value.sidebarOpen
    );

    function toggleSidebar() {
        interfaceGlobalProperties.value.sidebarOpen =
            !interfaceGlobalProperties.value.sidebarOpen;
    }

    const fontSize = computed(() => interfaceGlobalProperties.value.fontSize);
    const fontSizeStyle = computed(
        () => interfaceGlobalProperties.value.fontSize + "px"
    );

    function changeFontSize(newFontSize) {
        interfaceGlobalProperties.value.fontSize = newFontSize;
    }

    const theme = computed(() => interfaceGlobalProperties.value.theme);

    function changeTheme(theme) {
        interfaceGlobalProperties.value.theme = theme;
        const themeLink = document.querySelector('link[href*="/themes/"]');
        themeLink.href = "/themes/" + theme + "/theme.css";
    }

    return {
        toggleSidebar,
        sidebarOpen,
        changeFontSize,
        fontSize,
        fontSizeStyle,
        changeTheme,
        theme,
        interfaceGlobalProperties,
    };
};
